export const ALERT_TYPES = {
  NEGATIVE: 'NEGATIVE',
  UNREAD: 'UNREAD',
  TOTAL: 'TOTAL',
}

export const ALERT_TYPES_COLORS = {
  NEGATIVE: '#E0505B',
  UNREAD: '#0553A5',
  TOTAL: 'TOTAL',
}

export const COLUMN_IDS = {
  STT: 'STT',
  TYPE_DESCRIPTION: 'TYPE_DESCRIPTION',
  DATE: 'createDate',
  PORTFOLIO: 'profilePortfoliosList',
}

export const SENTIMENT_TYPE_ID = {
  POSITIVE: 1,
  NEGATIVE: 2,
  INFORMATIVE: 3,
}

export const SENTIMENT_COLOR_BY_ID = {
  [SENTIMENT_TYPE_ID.POSITIVE]: '#3DA967',
  [SENTIMENT_TYPE_ID.NEGATIVE]: '#E0505B',
  [SENTIMENT_TYPE_ID.INFORMATIVE]: '#0553A5',
}

export const SENTIMENT_ICON_BY_ID = {
  [SENTIMENT_TYPE_ID.POSITIVE]: 'icon-arrow-up-circle',
  [SENTIMENT_TYPE_ID.NEGATIVE]: 'icon-arrow-down-circle',
  [SENTIMENT_TYPE_ID.INFORMATIVE]: 'icon-info-circle',
}
